import { getSentByUserIdFromActivity } from 'app/shared/modules/DisclosureDelivery/DisclosureDelivery.utils';
import { createSelector } from 'reselect';

import { selectLoanApplication } from './loanApplication.selectors';

const selectDisclosureActivity = createSelector(
  selectLoanApplication,
  ({ disclosureActivity }) => disclosureActivity,
);

export const selectDisclosureActivityEntries = createSelector(
  selectDisclosureActivity,
  disclosureActivity => disclosureActivity?.entries ?? [],
);

export const selectIsDisclosureActivityUnavailable = createSelector(
  selectDisclosureActivity,
  disclosureActivity => !!disclosureActivity?.isUnavailable,
);

export const selectDisclosureActivitySentByUserId = createSelector(
  selectDisclosureActivityEntries,
  getSentByUserIdFromActivity,
);
